module.exports = __webpack_public_path__ + "assets/img/7.b6d76dc0.jpg";